import useGlobalData from '@hooks/useGlobalData';
import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import { MenuItemFirstLevel } from './Menu.styles';
import tw, { styled } from 'twin.macro';

type MenuLinkProps = {
  page: Queries.PageFragment;
  isFirstLevel?: boolean;
};

const MenuLink = ({ page, isFirstLevel = false }: MenuLinkProps) => {
  const { getInternalLink } = useGlobalData();
  const { pathname } = useLocation();
  const url = getInternalLink({ page });
  const isActive = url === pathname;

  return (
    <li>
      <StyledLink to={url}>
        <StyledLinkText
          isFirstLevel={isFirstLevel}
          isActive={isActive}
          title={page.elements.title.value}
        >
          {page.elements.short_title.value}
        </StyledLinkText>
      </StyledLink>
    </li>
  );
};

const StyledLink = styled(Link)(() => [tw`block`]);

const StyledLinkText = styled.span(
  ({ isActive, isFirstLevel }: { isActive: boolean; isFirstLevel: boolean }) => [
    isActive && tw`text-link font-bold`,
    isFirstLevel && MenuItemFirstLevel,
    !isFirstLevel && tw`pl-5 py-2 text-sm`,
    tw`block`,
    tw`hover:text-link`,
  ]
);
export default MenuLink;
